/**
 * Generates a string consisting of a specified number of spaces.
 *
 * @param length - The number of spaces to include in the generated string.
 * @returns A string containing the specified number of spaces.
 */
export const generateEmptyString = (length: number): string => {
  return Array.from({ length }, () => ' ').join('');
};
export const getInitials = (name: string): string => {
  const parts = name.trim().split(' ');
  if (parts.length === 1) return parts[0][0]?.toUpperCase() || '';
  return (parts[0][0] + parts[1][0])?.toUpperCase();
};
export const isValidUrl = (value: string): boolean => {
  try {
    const raw = value.trim();
    if (!raw) return false;
    const withProtocol = /^(https?:)?\/\//i.test(raw) ? raw : `https://${raw}`;
    const { hostname } = new URL(withProtocol);

    return hostname.includes('.');
  } catch {
    return false;
  }
};
